<template>
    <div id="contenedor-listado-desktop">
    <v-data-table :headers="headers" :items="listadoEntesFiscalizadores" :items-per-page="20">
      <template v-slot:[`item.acciones`]="{ item }">
        <opciones :enteFiscalizador="item"></opciones>
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        <fecha-humano :fecha="new Date(item.createdAt)"></fecha-humano>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import Opciones from './Opciones.vue';
import FechaHumano from '@/components/FechaHumano.vue';

export default {
  name: 'ListadoEntesFiscalizadoresDesktop',
  props: {
    listadoEntesFiscalizadores: {
      type: Array,
      required: true,
    },
  },
  components: {
    Opciones,
    FechaHumano,
  },
  data() {
    return {
      headers: [
        { text: 'Descripción', value: 'descripcion', sortable: true },
        { text: 'F. Registro', value: 'createdAt' },
        {
          text: '', value: 'acciones', align: 'end', sortable: false,
        },
      ],
    };
  },
};
</script>
